<div class="min-h-screen min-w-max bg-background-500">
  <router-outlet></router-outlet>
</div>
